import gql from 'graphql-tag';

export default gql`
    query GetJobLogMetaData($jobId: Int) {
        getJobLogMetaData(jobId: $jobId) {
            types {
                id
                descrip
            }
            issues {
                jobLogIssueId
                descrip
                jobLogTypeId
            }
            rootcauses {
                id
                descrip
            }
            locationLOFAs {
                id
                descrip
            }
        }
    }
`;
